import { BaseDto } from "../base/baseDto.model"

export class UpdateGrupoTipoGarantiaInquilinoRequest extends BaseDto{
  public idGrupo!:number
  public idGrupoTipoGarantia!:number
  public idInquilino!: number
}
